import { Trans } from '@lingui/macro';
import { CallSettingsFieldSection } from './CallSettingsFieldSection';
import TestFormSection from '../TestFormSection/TestFormSection';

export const VoipPhoneCallSettingsSection = () => {
    return (
        <TestFormSection title={<Trans>Call Settings</Trans>}>
            <CallSettingsFieldSection />
        </TestFormSection>
    );
};
